import React, {Component} from 'react';
import {
    Table
} from 'reactstrap';
import './ActiveConsentsList.css';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RemoveActiveConsentModal from "./removeActiveConsentModal/RemoveActiveConsentModal.container";
import {sharedLabelsPath} from "../../../../reducers/common/localization";
import AddPeriodPopover from "./addPeriodPopover/AddPeriodPopover.container";
import IconContainer from "../../../commonComponents/iconContainer/IconContainer";
import {REVOKED} from "../../../../reducers/consent/consents";
import FormWrapper from "../../../commonComponents/formWrapper/FormWrapper.container";
import PaginationActiveConsents from '../../../commonComponents/paginationComponent/PaginationActiveConsents.container';
import moment from 'moment';

class ActiveConsentList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isModalOpen: false,
            consentToRemoveData: null,
            consentToExtendId: null,
            consentToExtendExpireDate: null
        }
    }

    componentWillMount() {
        this.props.onMount();
    }

    render() {
        return (
            <div className='active-consents-list-container'>
                <FormWrapper successMessage={_.get(this.props.translation, 'consents.remove_consent_success_label')}>
                    <h4 className='page-label'>{_.get(this.props.translation, 'consents.active_consents_label')}</h4>
                    <PaginationActiveConsents/>
                    {this.renderTable()}
                    {/* TODO: uncomment when ability to configure prior consent will be added
                <Button tag={Link}
                        color='success'
                        to="/configure-prior-consent">
                    {_.get(this.props.translation, 'consents.grant_consent_button')}
                </Button>*/}
                    <RemoveActiveConsentModal data={this.state.consentToRemoveData}
                                              onRemove={this.handleRemoveConsent}/>
                    <AddPeriodPopover target={this.state.consentToExtendId}
                                      onExpandConsent={this.handleExpandConsentButtonClick}
                                      currentExpireDate={this.state.consentToExtendExpireDate}
                                      toggle={this.closeAddPeriodPopover}
                                      isOpen={!_.isNil(this.state.consentToExtendId)}/>
                </FormWrapper>
            </div>
        );
    }

    renderTable = () => {
        if (this.props.loading) {
            return (
                <div className="active-consents-list-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if (_.isNil(this.props.data) || this.props.data.length === 0) {
            return (
                <div className="active-consents-list-status-message-container">
                    <h6>{_.get(this.props.translation, 'consents.no_active_consents_label')}</h6>
                </div>
            );
        }

        return (
            <Table className='active-consents-list-table'>
                <thead>
                <tr>
                    <th>{_.get(this.props.translation, 'consents.person_label')}</th>
                    <th>{_.get(this.props.translation, 'consents.job_label')}</th>
                    <th>{_.get(this.props.translation, sharedLabelsPath.company_label)}</th>
                    <th>{_.get(this.props.translation, sharedLabelsPath.email_label)}</th>
                    <th>{_.get(this.props.translation, 'consents.requested_label')}</th>
                    <th>{_.get(this.props.translation, 'consents.valid_till_label')}</th>
                    <th/>
                </tr>
                </thead>
                <tbody>
                {this.renderActiveConsentsData()}
                </tbody>
            </Table>
        );
    };

    renderActiveConsentsData = () => {
        return _.map(this.props.data, (consentData, index) => (
            <tr key={index}>
                <td className='person-td'
                    data-th={_.get(this.props.translation, 'consents.person_label') + ':'}>{this.renderPersonName(consentData)}</td>
                <td className='job-td'
                    data-th={_.get(this.props.translation, 'consents.job_label') + ':'}>{consentData.jobTitle}</td>
                <td className='company-td'
                    data-th={_.get(this.props.translation, sharedLabelsPath.company_label) + ':'}>
                    {consentData.companyName ? consentData.companyName + ", " + _.get(this.props.translation, 'countries.' + consentData.countryCode) : '-'}
                </td>
                <td className='email-td' data-th={_.get(this.props.translation, sharedLabelsPath.email_label) + ':'}>
                    {consentData.email ? (<a href={"mailto:" + consentData.email}>{consentData.email}</a>) : '-'}
                </td>
                <td className='requested-td' data-th={_.get(this.props.translation, 'consents.requested_label') + ':'}>
                    {moment(consentData.requestDate).format('LL')}
                </td>
                <td className='valid-till-td' data-th={_.get(this.props.translation, 'consents.valid_till_label') + ':'}>
                    {_.isNil(consentData.expireDate) ? _.get(this.props.translation, 'consents.periods.forever_label') : moment(consentData.expireDate).format('LL')}
                </td>
                {/* Note: no ability to extend consent period in current version
                <td>
                    {this.renderPeriodContainer(consentData)}
                </td>*/}
                <td className="consent-controls">
                    <span className="revoke-consent-icon-container"
                        onClick={this.handleRemoveButtonClick(consentData)}>
                            <IconContainer icon='trash' title={_.get(this.props.translation, 'consents.remove_consent_label')}/>
                    </span>
                </td>
            </tr>
        ))
    };

    renderPersonName = (consentData) => {
        if (_.isNil(consentData.firstName) && _.isNil(consentData.lastName)) {
            return '-';
        } else if (_.isNil(consentData.firstName) && !_.isNil(consentData.lastName)) {
            return consentData.lastName;
        } else if (!_.isNil(consentData.firstName) && _.isNil(consentData.lastName)) {
            return consentData.firstName;
        } else {
            return consentData.firstName + ' ' + consentData.lastName;
        }
    };

    /*Note: no ability to extend consent period in current version
    renderPeriodContainer = (consentData) => {
        if (_.isNil(consentData.expireDate)) {
            return (<div className='period-container'>{_.get(this.props.translation, 'consents.periods.forever_label')}</div>)
        } else {
            return (
                <div className='period-container'>
                    {consentData.expireDate.format('LL')}
                    <span className="edit-consent-icon-container"
                          id={"edit-consent-icon-container" + consentData.id}
                          onClick={this.handleAddButtonClick(consentData)}>
                        <IconContainer icon='add'/>
                    </span>
                </div>
            )
        }
    };*/

    handleAddButtonClick = (consent) => () => {
        this.setState({
            consentToExtendId: "edit-consent-icon-container" + consent.id,
            consentToExtendExpireDate: consent.expireDate
        });
    };

    closeAddPeriodPopover = () => {
        this.setState({
            consentToExtendId: null,
            consentToExtendExpireDate: null
        });
    };

    handleExpandConsentButtonClick = () => {
        this.setState({consentToExtendId: null, consentToExtendExpireDate: null});
        //TODO: save new consent period
    };

    handleRemoveButtonClick = (consentData) => () => {
        this.setState({consentToRemoveData: consentData});
        this.props.onRemoveButtonClick();
    };

    handleRemoveConsent = () => {
        let data = {
            status: REVOKED
        };

        this.props.onRemove(this.state.consentToRemoveData.id, data);
    };
}

ActiveConsentList.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
    translation: PropTypes.object,
    onMount: PropTypes.func.isRequired,
    onRemoveButtonClick: PropTypes.func
};

export default ActiveConsentList;



// WEBPACK FOOTER //
// ./src/components/consentManagement/consentsList/activeConsentsList/ActiveConsentsList.js